import {Component} from '@angular/core';
import {
  StudiefinancieringAangeverComponent
} from './studiefinanciering-aangever/studiefinanciering-aangever.component';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-studiefinanciering',
  templateUrl: './studiefinanciering.component.html',
  styleUrls: ['./studiefinanciering.component.scss'],
  imports: [
    StudiefinancieringAangeverComponent
  ]
})
export class StudiefinancieringComponent {
}

